//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SERVER } from "@/api/apiConfig.js";

export default {
  name: "about",
  data() {
    return {
      appVersion: "...",
      h5Version: "...",
      h5VersionNum: "...",
      url: ""
    };
  },
  methods: {
    //返回上一页
    onClickLeft(){
      // this.$router.go(-1)
      try {
        this.$router.back()
        let isIos = /iPad|iPhone|iPod|ios/.test(navigator.userAgent) && !window.MSStream;
        if(isIos){
          window.webkit.messageHandlers.onExitPage.postMessage({"page":"about"});
        }else{
          window.AndroidInterface.onExitPage()
        }
      } catch (error) {
        console.log(error)
      }
    }
  },
  mounted() {
    // console.log(this.$i18n.locale);
    //this.appVersion = this.NATIVEDATA.appVersion;
    //this.h5Version = SERVER.VERSION;
    //this.h5VersionNum = SERVER.VERSION_NUM;
    //this.url = SERVER.URL;
  }
};



// WEBPACK FOOTER //
// ./src/pages/me/setting/about.vue